<script>
export default {
  props: ['initreports', 'categories'],
  data() {
    return {
      loading: false,
      reports: [],
      filters: {
        keyword: '',
        area: '',
        categories: []
      }
    }
  },
  mounted() {
    // this.reports = this.initreports;
    this.filterMap();
  },
  methods: {
    filterMap() {
      this.loading = true;
      axios.get('/reports', {
          params: this.filters
      })
      .then((response) => {
        this.reports = response.data.reports;
        this.$nextTick(() => {
          this.loading = false;
        });
      })
      .catch((error) => {
        this.loading = false;
      });
    },

    resetFilters() {  
      this.$set(this.filters, 'categories', []);
      this.filterMap();
    },

    selectCategory(category) {
      category.children.forEach(item => {
         this.filters.categories.indexOf(item.id) === -1 && this.filters.categories.push(item.id)
      });
      this.filters.categories.push(category.id);
     this.filterMap();
    },

    countSelectedCategories(categories) {
      let categories_ids = categories.map(({ id }) => id)
      let count = 0;
      categories_ids.forEach(id => {
         this.filters.categories.indexOf(id) >= 0 && count++;
      });
      if(count == 0){
        return '';
      } 
      return ` (${count})`;
    }
  }
}
</script>